import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MapPin, CalendarDays, BadgeCheck, MessageCircle } from "lucide-react";
import AdCard from "../components/site/AdCard";
import { http } from "../lib/api";
import { siteUrl } from "../lib/site";

export default function Seller() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { http.get(`/sellers/${id}`).then((r) => setS(r.data)).catch(() => setMissing(true)); }, [id]);

  if (missing) return <div className="py-20 text-center" data-testid="seller-not-found">Seller सापडला नाही. <Link to="/buy" className="text-[var(--buy)]">जाहिराती पहा</Link></div>;
  if (!s) return <div className="py-20 text-center text-slate-500">Loading...</div>;

  const share = encodeURIComponent(`${s.name} यांच्या 99Bazaar वरील सर्व जाहिराती पहा: ${siteUrl()}/seller/${s.id}`);
  return (
    <div className="max-w-7xl mx-auto px-4 py-8" data-testid="seller-page">
      <div className="bg-white rounded-2xl border border-slate-200 p-6 flex flex-col sm:flex-row sm:items-center gap-5">
        <span className="w-20 h-20 rounded-full bg-[var(--navy)] text-white font-display font-extrabold text-3xl flex items-center justify-center shrink-0">{s.name[0].toUpperCase()}</span>
        <div className="flex-1">
          <h1 className="font-display font-extrabold text-3xl text-[var(--navy)] flex items-center gap-2" data-testid="seller-name">{s.name} <BadgeCheck className="w-6 h-6 text-[var(--buy)]" /></h1>
          <div className="mt-1 flex flex-wrap gap-4 text-sm text-slate-600">
            <span className="flex items-center gap-1"><MapPin className="w-4 h-4" /> {s.taluka}, {s.district}</span>
            <span className="flex items-center gap-1"><CalendarDays className="w-4 h-4" /> Member since {new Date(s.member_since).toLocaleDateString("en-IN", { month: "short", year: "numeric" })}</span>
            <span className="font-semibold text-[var(--navy)]" data-testid="seller-ad-count">{s.ads.length} Live जाहिराती</span>
          </div>
          <p className="mt-2 text-xs text-slate-500">Mobile OTP ने Verified विक्रेता · थेट संपर्क, नो ब्रोकर</p>
        </div>
        <a href={`https://wa.me/?text=${share}`} target="_blank" rel="noopener noreferrer" className="h-11 px-4 rounded-full bg-[#25D366] text-white text-sm font-semibold flex items-center gap-2" data-testid="seller-share-whatsapp"><MessageCircle className="w-4 h-4" /> Profile Share करा</a>
      </div>
      <h2 className="mt-8 font-display font-bold text-2xl text-[var(--navy)]">या विक्रेत्याच्या जाहिराती</h2>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">{s.ads.map((ad) => <AdCard key={ad.id} ad={ad} />)}</div>
      {s.ads.length === 0 && <p className="py-10 text-center text-slate-500">सध्या Live जाहिरात नाही.</p>}
    </div>
  );
}
